const parseImageURL = (image) => {
  return (image && image.url) ? image.url() : null;
}

export default parseImageURL
